export const SUPPORT_WHATSAPP = "+4915218483329";
export const SUPPORT_WHATSAPP_LINK = "https://wa.me/4915218483329";

export const VEHICLE_TYPES = ["Sprinter", "Van", "3.5t", "7.5t", "12t", "40t", "Container truck"];

export const JOB_CATEGORIES = [
  "Sprinter / van delivery",
  "Box pickup",
  "Furniture moving",
  "Pallet delivery",
  "Tyre pickup",
  "Export goods pickup",
  "Local delivery",
  "Long-distance delivery",
  "3.5t truck transport",
  "7.5t truck transport",
  "12t truck transport",
  "40t truck transport",
  "Container transport",
];

export const waLink = (number, text) => {
  if (!number) return null;
  const clean = String(number).replace(/[^0-9]/g, "");
  return `https://wa.me/${clean}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
};

export const TRANSPORT_SERVICES = [
  "Local delivery",
  "Long-distance delivery",
  "Export pickup",
  "Pallet delivery",
  "Furniture moving",
  "Box pickup",
  "Tyre pickup",
];

export const COUNTRIES = ["Germany", "Netherlands", "Belgium", "France", "Poland", "Austria", "United Kingdom", "Italy", "Spain", "Czechia", "Other"];

export const REVIEW_CRITERIA = [
  { key: "overall", label: "Overall" },
  { key: "punctuality", label: "Punctuality" },
  { key: "communication", label: "Communication" },
  { key: "vehicle_condition", label: "Vehicle condition" },
  { key: "careful_handling", label: "Careful handling" },
  { key: "professionalism", label: "Professionalism" },
];

export const jobStatusLabel = (job) => {
  const s = job.status;
  if (s === "open") return (job.applications_count > 0) ? "Quotes Received" : "Open";
  return { assigned: "Assigned", in_progress: "In Progress", delivered: "Delivered", completed: "Completed" }[s] || s;
};

export const jobStatusColor = (s) => ({
  open: "bg-primary text-white",
  assigned: "bg-accent text-foreground",
  in_progress: "bg-accent text-foreground",
  delivered: "bg-primary text-white",
  completed: "bg-foreground text-white",
}[s] || "bg-muted text-muted-foreground");

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  containers: "https://images.unsplash.com/photo-1605732562742-3023a888e56e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  warehouse: "https://images.unsplash.com/photo-1689942010216-dc412bb1e7a9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  fleet: "https://images.pexels.com/photos/37169749/pexels-photo-37169749.jpeg?auto=compress&cs=tinysrgb&w=1200",
  tyres: "https://images.pexels.com/photos/3806252/pexels-photo-3806252.jpeg?auto=compress&cs=tinysrgb&w=1200",
};
